<template>
  <div
    v-if="isShow"
    ref="iuOverlay"
    class="iu-widget__overlay"
    :class="{ 'iu-widget--in-drag': inDrag }"
    @click="isShow = false"
    @dragover.prevent.stop="inDrag = true"
    @dragleave.prevent.stop="inDrag = false"
    @drop.prevent.stop="uploadFromDrop"
  >
    <div v-if="settings.custom_style" v-html="settings.custom_style" />
    <div
      ref="iuPopup"
      class="iu-widget__popup"
      @click.stop
      @dragover.prevent.stop="inDrag = true"
    >
      <template v-if="currentStep !== 'congrats'">
        <div class="iu-widget__close" @click="isShow = false">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1C8.33333 8.33333 23 23 23 23"
              stroke="#2C2C2C"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M23 1C15.6667 8.33333 1 23 1 23"
              stroke="#2C2C2C"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <div class="iu-widget__title">Добавь свои фото</div>
        <div class="iu-widget-progress">
          <div
            class="iu-widget-progress__step"
            :class="{
              'iu-widget-progress__step--active': currentStep === 'upload',
            }"
          >
            <svg
              width="28"
              height="24"
              viewBox="0 0 28 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.5 11.5L14 17L19.5 11.5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14 17L14 1"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 12V19C1 21.2091 2.79086 23 5 23H23C25.2091 23 27 21.2091 27 19V12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            class="iu-widget-progress__step"
            :class="{
              'iu-widget-progress__step--active': currentStep === 'preview',
            }"
          >
            <svg
              width="28"
              height="20"
              viewBox="0 0 28 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="14"
                cy="15"
                r="4"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14 6V1"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.83699 8.09676L3 5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 14C3.6819 9.2007 8.50097 6 14 6C19.499 6 24.3181 9.20068 27 14"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22.163 8.09676L25 5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            class="iu-widget-progress__step"
            :class="{
              'iu-widget-progress__step--active': currentStep === 'post',
            }"
          >
            <svg
              width="23"
              height="15"
              viewBox="0 0 23 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 6.77778L8.5 14L22 1"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <template v-if="['upload', 'preview'].includes(currentStep)">
          <div
            v-if="!limitIsFull && !uploadProcess"
            class="iu-widget-upload"
            :class="{
              'iu-widget-upload--short':
                uploadedFiles.length && uploadedFiles.length < maxLimit,
            }"
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="8"
                y="7.9541"
                width="32"
                height="31.8168"
                rx="2"
                stroke="#2C2C2C"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.00018 30.3779L14.8583 23.5591C15.6416 22.7803 16.9115 22.7803 17.6948 23.5591L34.0002 39.7711"
                stroke="#2C2C2C"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M26.0002 31.305L30.7764 26.5561C31.168 26.1667 31.803 26.1667 32.1947 26.5561L39.4855 33.8053"
                stroke="#2C2C2C"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <ellipse
                cx="27"
                cy="16.9027"
                rx="3"
                ry="2.98283"
                stroke="#2C2C2C"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="iu-widget-upload__text">
              <span class="iu-widget-upload__input">
                <span class="iu-widget-upload__text--desktop"
                  >Загрузи фото с компьютера</span
                ><span class="iu-widget-upload__text--mobile"
                  >Загрузи фото с телефона</span
                >
              </span>
              <span class="iu-widget-upload__text--desktop">
                или<br />
                перетащи в эту область</span
              >
            </div>
            <div class="iu-widget-upload__hint">
              <span class="iu-widget-upload__hint--desktop">
                Допустимые форматы: .jpg, .png, .mp4, .mov<br />
                не более 5 файлов.
                <br />
                Размер одного файла – не более 50 МБ.
                <br />
                Минимальное соотношение – не менее 480px на одну сторону.
              </span>
              <span class="iu-widget-upload__hint--mobile">
                Не более 5 файлов
              </span>
            </div>
            <input
              title="Загрузи фото с компьютера"
              type="file"
              multiple
              accept="image/x-png, image/png, image/jpeg, video/*"
              @change="uploadFromInput"
            />
          </div>
          <div
            v-if="!uploadProcess && error"
            class="iu-widget-message iu-widget-upload__error"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16ZM12 6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6L10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13L12 6Z"
                fill="#2C2C2C"
              />
            </svg>
            <span>{{ error }}</span>
          </div>
          <div
            v-if="uploadProcess || uploadedFiles.length"
            class="iu-widget-preview"
          >
            <div v-if="uploadProcess" class="iu-widget-upload__progress">
              <div class="iu-widget-upload__loader">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.3334 1.66699C19.4493 1.66699 18.6015 2.01818 17.9764 2.6433C17.3512 3.26842 17 4.11627 17 5.00032C17 5.88438 17.3512 6.73223 17.9764 7.35735C18.6015 7.98247 19.4493 8.33366 20.3334 8.33366C21.2174 8.33366 22.0653 7.98247 22.6904 7.35735C23.3155 6.73223 23.6667 5.88438 23.6667 5.00032C23.6667 4.11627 23.3155 3.26842 22.6904 2.6433C22.0653 2.01818 21.2174 1.66699 20.3334 1.66699ZM20.3334 32.5003C19.6703 32.5003 19.0345 32.7637 18.5656 33.2326C18.0968 33.7014 17.8334 34.3373 17.8334 35.0003C17.8334 35.6634 18.0968 36.2992 18.5656 36.7681C19.0345 37.2369 19.6703 37.5003 20.3334 37.5003C20.9964 37.5003 21.6323 37.2369 22.1011 36.7681C22.57 36.2992 22.8334 35.6634 22.8334 35.0003C22.8334 34.3373 22.57 33.7014 22.1011 33.2326C21.6323 32.7637 20.9964 32.5003 20.3334 32.5003ZM35.5 18.8337C35.058 18.8337 34.6341 19.0093 34.3215 19.3218C34.009 19.6344 33.8334 20.0583 33.8334 20.5003C33.8334 20.9424 34.009 21.3663 34.3215 21.6788C34.6341 21.9914 35.058 22.167 35.5 22.167C35.9421 22.167 36.366 21.9914 36.6786 21.6788C36.9911 21.3663 37.1667 20.9424 37.1667 20.5003C37.1667 20.0583 36.9911 19.6344 36.6786 19.3218C36.366 19.0093 35.9421 18.8337 35.5 18.8337ZM5.33337 17.0003C4.93941 17.0003 4.5493 17.0779 4.18532 17.2287C3.82135 17.3794 3.49063 17.6004 3.21205 17.879C2.93348 18.1576 2.7125 18.4883 2.56174 18.8523C2.41097 19.2162 2.33337 19.6064 2.33337 20.0003C2.33337 20.3943 2.41097 20.7844 2.56174 21.1484C2.7125 21.5124 2.93348 21.8431 3.21205 22.1216C3.49063 22.4002 3.82135 22.6212 4.18532 22.772C4.5493 22.9227 4.93941 23.0003 5.33337 23.0003C5.72734 23.0003 6.11745 22.9227 6.48143 22.772C6.8454 22.6212 7.17612 22.4002 7.4547 22.1216C7.73327 21.8431 7.95425 21.5124 8.10501 21.1484C8.25578 20.7844 8.33337 20.3943 8.33337 20.0003C8.33337 19.6064 8.25578 19.2162 8.10501 18.8523C7.95425 18.4883 7.73327 18.1576 7.4547 17.879C7.17612 17.6004 6.8454 17.3794 6.48143 17.2287C6.11745 17.0779 5.72734 17.0003 5.33337 17.0003ZM31 5.16699C29.895 5.16699 28.8352 5.60598 28.0538 6.38738C27.2724 7.16878 26.8334 8.22859 26.8334 9.33366C26.8334 10.4387 27.2724 11.4985 28.0538 12.2799C28.8352 13.0613 29.895 13.5003 31 13.5003C32.1051 13.5003 33.1649 13.0613 33.9463 12.2799C34.7277 11.4985 35.1667 10.4387 35.1667 9.33366C35.1667 8.22859 34.7277 7.16878 33.9463 6.38738C33.1649 5.60598 32.1051 5.16699 31 5.16699ZM9.66671 27.667C8.87106 27.667 8.108 27.9831 7.54539 28.5457C6.98278 29.1083 6.66671 29.8713 6.66671 30.667C6.66671 31.4626 6.98278 32.2257 7.54539 32.7883C8.108 33.3509 8.87106 33.667 9.66671 33.667C10.4624 33.667 11.2254 33.3509 11.788 32.7883C12.3506 32.2257 12.6667 31.4626 12.6667 30.667C12.6667 29.8713 12.3506 29.1083 11.788 28.5457C11.2254 27.9831 10.4624 27.667 9.66671 27.667ZM31 28.667C30.7374 28.667 30.4773 28.7187 30.2347 28.8192C29.992 28.9197 29.7715 29.0671 29.5858 29.2528C29.4001 29.4385 29.2528 29.659 29.1523 29.9016C29.0518 30.1443 29 30.4043 29 30.667C29 30.9296 29.0518 31.1897 29.1523 31.4324C29.2528 31.675 29.4001 31.8955 29.5858 32.0812C29.7715 32.2669 29.992 32.4142 30.2347 32.5147C30.4773 32.6153 30.7374 32.667 31 32.667C31.2627 32.667 31.5228 32.6153 31.7654 32.5147C32.0081 32.4142 32.2285 32.2669 32.4143 32.0812C32.6 31.8955 32.7473 31.675 32.8478 31.4324C32.9483 31.1897 33 30.9296 33 30.667C33 30.4043 32.9483 30.1443 32.8478 29.9016C32.7473 29.659 32.6 29.4385 32.4143 29.2528C32.2285 29.0671 32.0081 28.9197 31.7654 28.8192C31.5228 28.7187 31.2627 28.667 31 28.667ZM9.66671 6.33366C9.27274 6.33366 8.88263 6.41126 8.51866 6.56202C8.15468 6.71278 7.82396 6.93376 7.54539 7.21234C7.26681 7.49091 7.04583 7.82163 6.89507 8.18561C6.74431 8.54958 6.66671 8.93969 6.66671 9.33366C6.66671 9.72762 6.74431 10.1177 6.89507 10.4817C7.04583 10.8457 7.26681 11.1764 7.54539 11.455C7.82396 11.7336 8.15468 11.9545 8.51866 12.1053C8.88263 12.2561 9.27274 12.3337 9.66671 12.3337C10.0607 12.3337 10.4508 12.2561 10.8148 12.1053C11.1787 11.9545 11.5095 11.7336 11.788 11.455C12.0666 11.1764 12.2876 10.8457 12.4383 10.4817C12.5891 10.1177 12.6667 9.72762 12.6667 9.33366C12.6667 8.93969 12.5891 8.54958 12.4383 8.18561C12.2876 7.82163 12.0666 7.49091 11.788 7.21234C11.5095 6.93376 11.1787 6.71278 10.8148 6.56202C10.4508 6.41126 10.0607 6.33366 9.66671 6.33366Z"
                    fill="#EF3E42"
                  />
                </svg>
              </div>
              Обработаны {{ filesProcessed }} из
              {{ filesToUpload.length }} фото.&nbsp;
              <span v-if="isVideoCompression"> Сжатие медиа </span>
              <span v-else> Загрузка медиа </span>
            </div>
            <div v-else class="iu-widget-message">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM15.9069 9.00691C16.2974 8.61639 16.2974 7.98322 15.9069 7.5927C15.5164 7.20217 14.8832 7.20217 14.4927 7.5927L9.7998 12.2856L7.50691 9.9927C7.11639 9.60217 6.48322 9.60217 6.0927 9.9927C5.70217 10.3832 5.70217 11.0164 6.0927 11.4069L9.0927 14.4069C9.48322 14.7974 10.1164 14.7974 10.5069 14.4069L15.9069 9.00691Z"
                  fill="#2C2C2C"
                />
              </svg>
              <span>{{ uploadedFiles.length }} фото успешно загружены</span>
            </div>
            <div class="iu-widget__media-list">
              <div
                v-for="(media, index) in uploadedFiles"
                :key="media.id"
                class="iu-widget__media-item"
              >
                <img
                  ref="uploadedImages"
                  :src="media.url"
                  class="iu-widget-item-image"
                  @error="reloadImage(index, media.url)"
                />
                <div
                  class="iu-widget-item-close"
                  @click="uploadedFiles.splice(index, 1)"
                >
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1C8.33333 8.33333 23 23 23 23"
                      stroke="#2C2C2C"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M23 1C15.6667 8.33333 1 23 1 23"
                      stroke="#2C2C2C"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!uploadProcess && uploadedFiles.length"
            class="iu-widget__controls"
          >
            <div class="iu-widget__next-button" @click="currentStep = 'post'">
              Далее
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="error" class="iu-widget-message iu-widget-upload__error">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16ZM12 6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6L10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13L12 6Z"
                fill="#2C2C2C"
              />
            </svg>
            <span>{{ error }}</span>
          </div>
          <div class="iu-widget__post-form">
            <label>Имя *</label>
            <input v-model="username" type="text" @input="error = null" />
            <label>E-mail *</label>
            <input v-model="email" type="text" @input="error = null" />
            <label class="iu-widget-checkbox">
              <input v-model="agreedWithRules" type="checkbox" />
              <div class="iu-widget-checkbox__toggle" />
              <div
                v-if="settings.personal_data_agreement_content"
                class="iu-widget-checkbox__label"
                v-html="settings.personal_data_agreement_content"
              />
              <div v-else class="iu-widget-checkbox__label">
                Согласен с
                <a :href="settings.link_personal_data_agreement" target="_blank"
                  >правилами пользования сайтом</a
                >
              </div>
            </label>
          </div>
          <div class="iu-widget__controls">
            <div
              class="iu-widget__back-button"
              @click="currentStep = 'preview'"
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 8.5L10 13.5"
                  stroke="#2C2C2C"
                  stroke-linecap="round"
                />
                <path
                  d="M5 8.5L10 3.5"
                  stroke="#2C2C2C"
                  stroke-linecap="round"
                />
              </svg>
              <span>Вернуться</span>
            </div>
            <div class="iu-widget__next-button" @click="saveAsPost">
              опубликовать
            </div>
          </div>
        </template>
        <div class="iu-widget__logo">
          <svg
            width="56"
            height="17"
            viewBox="0 0 56 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M49.6151 0.0244141C53.139 0.0244141 56 2.93703 56 6.52454C56 10.112 53.139 13.0247 49.6151 13.0247C46.0913 13.0247 43.2303 10.112 43.2303 6.52454C43.2303 2.93703 46.0913 0.0244141 49.6151 0.0244141ZM49.6151 2.05507C52.0382 2.05507 54.0054 4.05776 54.0054 6.52454C54.0054 8.99132 52.0382 10.994 49.6151 10.994C47.1921 10.994 45.2249 8.99132 45.2249 6.52454C45.2249 4.05776 47.1921 2.05507 49.6151 2.05507ZM49.6151 2.70992C51.6831 2.70992 53.3621 4.41921 53.3621 6.52454C53.3621 8.62986 51.6831 10.3392 49.6151 10.3392C47.5472 10.3392 45.8682 8.62986 45.8682 6.52454C45.8682 4.41921 47.5472 2.70992 49.6151 2.70992Z"
              fill="#1E8FD1"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M36.4055 9.61766V9.66101C36.4055 10.9477 37.3773 11.9886 38.5785 11.9886L38.59 11.9886H38.591H38.5921L38.6035 11.9886C39.8047 11.9886 40.7764 10.9477 40.7764 9.66101V9.61766H40.79V6.49541H41.9237V13.4288C41.9237 15.395 40.4255 16.9997 38.59 16.9997C38.4619 16.9997 38.3353 16.9919 38.2108 16.9767V15.7186C38.3381 15.7434 38.4694 15.7564 38.6035 15.7564C39.8047 15.7564 40.7764 14.7155 40.7764 13.4288V13.3854H40.79V12.3398C40.2026 12.8942 39.4327 13.2314 38.5921 13.232H38.591H38.59C36.7554 13.2307 35.2584 11.6265 35.2584 9.66101V6.49541H36.392V9.61766H36.4055ZM28.5761 9.61766H28.5896V9.66101C28.5896 10.9477 29.5614 11.9886 30.7626 11.9886L30.7741 11.9886H30.7751H30.7761L30.7875 11.9886C31.9888 11.9886 32.9606 10.9477 32.9606 9.66101V9.61766H32.9741V6.49541H34.1077V9.66101C34.1077 11.6265 32.6108 13.2307 30.7761 13.232H30.7751H30.7741C28.9394 13.2307 27.4424 11.6265 27.4424 9.66101V6.49541H28.5761V9.61766ZM17.5134 13.2185H14.2391V12.0713H17.5134C17.7785 12.0713 17.9641 11.9768 18.057 11.8554C18.1099 11.7879 18.1365 11.6935 18.1497 11.599C18.163 11.491 18.1365 11.3695 18.0967 11.2616C17.9906 11.0052 17.7521 10.7622 17.3676 10.6408L17.1422 10.5868L15.8033 10.2359L15.7769 10.2224C15.008 9.99302 14.5175 9.48013 14.2921 8.91332C14.1861 8.62995 14.1463 8.33307 14.1728 8.0361C14.1993 7.72569 14.3054 7.44233 14.491 7.19944C14.7958 6.79455 15.2863 6.52463 15.9359 6.52463H18.8319V7.67177H15.9492C15.6841 7.67177 15.4984 7.76625 15.4056 7.8877C15.3527 7.95514 15.3261 8.04962 15.3128 8.1441C15.2996 8.25203 15.3261 8.36003 15.3659 8.48147C15.472 8.73787 15.7105 8.98084 16.095 9.10228L16.3203 9.15628L17.6592 9.50717L17.6857 9.52061C18.4414 9.75006 18.9318 10.2629 19.1572 10.8298C19.2633 11.1131 19.303 11.4235 19.2765 11.707C19.25 12.0173 19.1439 12.3008 18.9584 12.5436C18.6535 12.9485 18.1762 13.2185 17.5134 13.2185ZM12.8319 13.2183H11.7051V6.55796C11.8858 6.54459 12.0672 6.53791 12.2486 6.53791H12.8319V13.2183ZM7.1322 13.2183H6.0054V7.68506V6.53791H7.1322V7.43689C7.7198 6.87909 8.42714 6.55143 9.33414 6.53799L9.33949 6.53791C9.69163 6.54343 10.0429 6.53869 10.3994 6.5902V7.7828C10.1986 7.74722 9.9831 7.72787 9.75887 7.72787C9.48144 7.72787 9.21737 7.75747 8.97811 7.81085C7.94128 7.98878 7.14526 8.94898 7.14526 10.1089L7.1322 10.5417V13.2183ZM21.1854 6.53815H23.333C25.1358 6.53815 26.6073 8.0361 26.6206 9.85806C26.6206 11.707 25.1491 13.2049 23.3462 13.2049C21.5434 13.2049 20.0719 11.707 20.0719 9.8715L20.0578 6.52463H20.0586V3.86142H21.1854V6.53815ZM2.26681 13.1913H1.14001V7.67154H0V6.52447H1.11948V5.55533C1.11948 3.58917 2.61766 1.98438 4.45318 1.98438C4.5814 1.98438 4.70787 1.99222 4.83235 2.00745V3.26555C4.70504 3.24069 4.57377 3.22771 4.43967 3.22771C3.23846 3.22771 2.25903 4.26864 2.25903 5.55533L2.26681 6.53791H4.67062V7.68506H2.26681V13.1913ZM23.2932 7.69873V7.68521H21.1854V9.83102H21.1987C21.1987 9.84454 21.1987 9.85806 21.1987 9.8715C21.1987 11.0726 22.1531 12.0443 23.333 12.0443C24.5128 12.0443 25.4672 11.0726 25.4672 9.8715C25.4672 8.67043 24.5128 7.69873 23.333 7.69873H23.2932ZM12.2505 3.86142C11.8757 3.86142 11.5691 4.17362 11.5691 4.55519C11.5691 4.98013 11.9523 5.31835 12.3868 5.23164C12.6508 5.17958 12.8638 4.9628 12.9149 4.69396C13.0001 4.2517 12.6679 3.86142 12.2505 3.86142Z"
              fill="#5F5F5F"
            />
          </svg>
        </div>
      </template>
      <template v-else>
        <div class="iu-widget-message iu-widget-message-congrats">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM15.9069 9.00691C16.2974 8.61639 16.2974 7.98322 15.9069 7.5927C15.5164 7.20217 14.8832 7.20217 14.4927 7.5927L9.7998 12.2856L7.50691 9.9927C7.11639 9.60217 6.48322 9.60217 6.0927 9.9927C5.70217 10.3832 5.70217 11.0164 6.0927 11.4069L9.0927 14.4069C9.48322 14.7974 10.1164 14.7974 10.5069 14.4069L15.9069 9.00691Z"
              fill="#2C2C2C"
            />
          </svg>
          <span>
            {{ uploadedFiles.length }} фото успешно отправлены на модерацию.
            <span>Вы получите уведомление на почту.</span>
          </span>
        </div>
      </template>
      <div
        v-if="inDrag"
        class="iu-widget-drop-area"
        :class="{
          'iu-widget-drop-area--limited': limitIsFull || uploadProcess,
        }"
      >
        <svg
          width="134"
          height="134"
          viewBox="0 0 134 134"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M67 122.834C97.8359 122.834 122.833 97.8362 122.833 67.0003C122.833 36.1644 97.8359 11.167 67 11.167C36.1641 11.167 11.1667 36.1644 11.1667 67.0003C11.1667 97.8362 36.1641 122.834 67 122.834Z"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M67 39.083L67 94.9163"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M39.0833 67L94.9166 67"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
// Modules
import axios from "axios";
// Mixins
import analytics from "../../common/mixins/analytics";
// Services
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import { redirectToAuthPage } from "../services";

export default {
  mixins: [analytics],

  props: ["propSettings"],
  data() {
    const { logged_in_email } = this.propSettings;

    return {
      settings: this.propSettings || {},
      maxLimit: 5,
      isShow: true,
      currentStep: "upload",
      filesToUpload: null,
      filesProcessed: 0,
      uploadedFiles: [],
      uploadProcess: false,
      error: null,
      username: "",
      email: logged_in_email || "",
      agreedWithRules: false,
      inDrag: false,
      labelItemPosition: ["url", "friPostId", "uploadPhotoCount"],
      categoryPostfix: "IUpload",
      isVideoCompression: false,
    };
  },

  mounted() {
    document.addEventListener("frisbuy:iu-open", this.showPopup);
  },
  beforeUnmount() {
    document.removeEventListener("frisbuy:iu-open", this.showPopup);
  },

  computed: {
    limitIsFull() {
      const { uploadedFiles, maxLimit } = this;

      return uploadedFiles.length >= maxLimit;
    },

    trackingSkuId() {
      const { skuId, groupId, categoryId } = this.settings;

      return (
        (skuId && `_sku${skuId}`) ||
        (groupId && `_skug${groupId}`) ||
        (categoryId && `_cat${categoryId}`) ||
        ""
      );
    },

    isUserLoggedIn() {
      const { logged_in_id, logged_in_email, logged_in_phone } = this.settings;

      return !!logged_in_id && !!logged_in_email && !!logged_in_phone;
    },
  },

  watch: {
    uploadedFiles: {
      handler(array) {
        if (!array.length) return;

        this.sendAnalyticEvent("UplphotoSelected", {
          link: location.href,
          linklabel: document.title,
        });
      },
      deep: true,
    },

    currentStep(newStepName, oldStepName) {
      if (newStepName === "post") {
        this.sendAnalyticEvent("UplphotoUploaded", {
          link: location.href,
          linklabel: document.title,
        });
      }

      if (oldStepName === "upload") return;

      this.error = null;
    },

    isShow: {
      handler(value) {
        const { logged_in_email } = this.settings;

        if (value) {
          this.sendAnalyticEvent("UplphotoOpen");

          if (this.settings.auth_page_url && !this.isUserLoggedIn) {
            const backUrl = window.location.href;
            redirectToAuthPage(this.settings.auth_page_url, backUrl);

            this.closePopup();
            return;
          }

          this.$nextTick(() => {
            const { $el } = this;

            document.body.appendChild($el);

            this.lockWindowScroll();
          });

          return;
        }

        this.unlockWindowScroll();

        this.currentStep = "upload";
        this.filesToUpload = null;
        this.filesProcessed = 0;
        this.uploadedFiles = [];
        this.uploadProcess = false;
        this.error = null;
        this.username = "";
        this.email = logged_in_email || "";
        this.agreedWithRules = false;
      },

      immediate: true,
    },
  },

  methods: {
    lockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      const scrollElement = customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "hidden";
    },

    unlockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      const scrollElement = customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "";
    },

    showPopup() {
      this.isShow = true;
    },

    closePopup() {
      this.isShow = false;
    },

    componentAction({ action }) {
      const { settings, trackingSkuId } = this;

      return `${action}_embedID${settings.embedId + trackingSkuId}`;
    },

    uploadFromDrop(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.dataTransfer;

      this.inDrag = false;

      if (limitIsFull || uploadProcess) return;

      this.filesToUpload = [...files].slice(0, maxLimit - uploadedFiles.length);

      uploadFiles();
    },

    uploadFromInput(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.target;

      if (limitIsFull || uploadProcess) return;

      this.filesToUpload = [...files].slice(0, maxLimit - uploadedFiles.length);

      uploadFiles();
    },

    uploadFiles() {
      const { filesToUpload, settings } = this;
      const { srcDomain, embedId } = settings;

      this.uploadProcess = true;
      this.filesProcessed = 0;
      this.error = null;

      filesToUpload.forEach((file) => {
        const formData = new FormData();

        formData.append("file", file, file.name);

        if (file.size > 50 * 1024 * 1024) {
          this.filesProcessed += 1;
          this.error = `${this.error || ""}Файл превышает размер 50 мегабайт`;

          if (this.filesProcessed !== filesToUpload.length) return;

          this.uploadProcess = false;
          this.filesToUpload = [];
          this.currentStep = "preview";

          return;
        }

        axios({
          url: DomainSubstitute(`${srcDomain}/api/1.0.0/customer/medias?embed_id=${embedId}`),
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progress) => {
            const isUploaded = progress.total === progress.loaded;

            if (isUploaded) {
              this.isVideoCompression = true;
            }
          },
        })
          .then(({ data }) => {
            const { request, response } = data;
            const { success, statusMessage } = request;
            const { post_media } = response.body;

            if (!success) {
              this.error = statusMessage;
              return;
            }

            this.uploadedFiles.push(post_media);
          })
          .catch((error) => {
            const { response } = error;

            if (!response || typeof response.data.request === "string") {
              if (error && response && response.status === 413) {
                this.error =
                  (this.error || "") +
                  `Файл '${file.name}' превышает размер 50 мегабайт` +
                  "\n";
                return;
              }

              this.error = "Ошибка на сервере, попробуйте позже";
              return;
            }

            if (this.error === null) {
              this.error = `${response.data.request.error}\n`;
            } else {
              this.error += `${response.data.request.error}\n`;
            }

            this.sendAnalyticEvent("UplphotoError", {
              link: location.href,
              linklabel: document.title,
              error: this.error,
            });
          })
          .finally(() => {
            this.filesProcessed += 1;

            if (this.filesProcessed !== filesToUpload.length) return;

            this.uploadProcess = false;
            this.isVideoCompression = false;
            this.filesToUpload = [];
            this.currentStep = "preview";
          });
      });
    },

    saveAsPost() {
      let { uploadedFiles, username, email, agreedWithRules, settings } = this;
      const { srcDomain, embedId, logged_in_id } = settings;
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      email = email.trim();

      this.error = null;

      if (!username) {
        this.error = "Пожалуйста, введите имя";
        return;
      }
      if (!email || !emailReg.test(email)) {
        this.error = "Пожалуйста, введите правильный E-mail адрес";
        return;
      }
      if (!agreedWithRules) {
        this.error =
          "Пожалуйста, подтвердите ознакомление с правилами пользования сайтом";
        return;
      }

      axios({
        url: DomainSubstitute(`${srcDomain}/api/1.0.0/customer/posts?embed_id=${embedId}`),
        method: "POST",
        data: {
          post_medias: uploadedFiles,
          email,
          username,
          logged_in_id,
          url: encodeURIComponent(location.href),
        },
      })
        .then(({ data }) => {
          const { success, statusMessage } = data.request;

          if (!success) {
            this.error = statusMessage;
            return;
          }

          this.sendAnalyticEvent("UplphotoOK", {
            link: location.href,
            linklabel: document.title,
            uploadPhotoCount: uploadedFiles.length,
          });

          this.currentStep = "congrats";

          setTimeout(() => {
            this.isShow = false;
          }, 3000);
        })
        .catch((error) => {
          const { response } = error;

          this.sendAnalyticEvent("UplphotoError", {
            link: location.href,
            linklabel: document.title,
            error: this.error,
          });

          if (response) {
            const { data } = response;

            this.error = data.request.error;
          } else {
            this.error = "Ошибка на сервере, попробуйте позже";
          }
        });
    },

    reloadImage(index, url) {
      /*
        NOTE: Backend cache return 404 error.
        To update cache I use random query param
      */
      const randomValue = Math.random().toString().slice(2);
      const randomQueryParam = `random_query_param=${randomValue}`;

      const fixedUrl = `${url}?recovery=true&${randomQueryParam}`;
      this.$refs.uploadedImages[index].src = fixedUrl;
    },
  },
};
</script>

<style lang="scss">
.iu-widget__overlay {
  font-family: Arial, Helvetica, sans-serif;
  background-color: rgba(77, 77, 77, 0.4);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  min-width: 100svw;
  min-height: 100svh;
  z-index: 99999999999999;
  animation: iu-show 0.2s linear;
  color: #2c2c2c;

  * {
    box-sizing: border-box;
  }

  a {
    color: inherit;
    text-decoration: none;
    border-bottom: 1px solid #c0c0c0;
  }

  &.iu-widget--in-drag {
    .iu-widget__popup {
      pointer-events: none;
    }
  }
}

.iu-widget__popup {
  width: 420px;
  background: #ffffff;
  padding: 24px;
  position: relative;
  max-height: 90%;
  overflow: auto;
}

.iu-widget-drop-area {
  position: absolute;
  background-color: rgba(30, 129, 189, 0.15);
  backdrop-filter: blur(5px);
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.iu-widget-drop-area--limited {
    background-color: rgba(189, 30, 30, 0.15);
    svg {
      transform: rotate(45deg);
    }
  }
}

.iu-widget__close {
  position: absolute;
  top: 17px;
  right: 17px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.iu-widget__title {
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  text-align: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-top: 22px;
}

.iu-widget__logo {
  height: 44px;
  width: calc(100% + 48px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 -24px -24px;
  border-top: 1px solid #eaeaea;
}

.iu-widget-progress {
  display: flex;
  padding-top: 24px;
  justify-content: center;
}

.iu-widget-progress__step {
  width: 48px;
  height: 48px;
  display: flex;
  color: #2c2c2c;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 100%;
  border: 2px solid currentColor;

  &:not(:first-child) {
    margin-left: 68px;

    &:before {
      content: "";
      border: 1px solid currentColor;
      border-radius: 2px;
      width: 56px;
      position: absolute;
      right: calc(100% + 6px);
      top: calc(50% - 1px);
    }
  }
}

.iu-widget-progress__step--active {
  & ~ .iu-widget-progress__step {
    color: #dfdfdf;
  }
}

.iu-widget-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px dashed #8fc0de;
  border-radius: 5px;
  margin: 24px 0;
  padding: 57px 32px;
  position: relative;

  + .iu-widget-upload__error {
    margin-top: 0;

    span {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  input {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    cursor: pointer;
  }
}

.iu-widget-upload--short {
  padding: 16px 16px 16px 60px;
  align-items: flex-start;
  position: relative;

  svg {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 16px;
    left: 24px;
  }

  .iu-widget-upload__text {
    text-align: left;
    margin-top: 0;
  }

  .iu-widget-upload__hint {
    text-align: left;
    margin-top: 12px;
  }
}

.iu-widget-upload__text {
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  margin-top: 16px;

  .iu-widget-upload__text--mobile {
    display: none;
  }
}

.iu-widget-upload__input {
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid #c0c0c0;
  line-height: 21px;
}

.iu-widget-upload__hint {
  font-size: 13px;
  line-height: 22px;
  color: #959595;
  text-align: center;
  margin-top: 20px;

  .iu-widget-upload__hint--mobile {
    display: none;
  }
}

.iu-widget-preview {
  margin: 24px 0;
  background-color: #f4f4f4;
  min-height: 145px;
}

.iu-widget-upload__loader {
  svg {
    margin-right: 20px;
    animation: spin 1s infinite linear;
  }
}

.iu-widget-upload__progress {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 18px 6px;
  color: #959595;
  font-size: 13px;
  line-height: 22px;
}

.iu-widget__media-list {
  display: flex;
  flex-wrap: wrap;
  padding: 8px;
}

.iu-widget__media-item {
  width: 53px;
  height: 53px;
  border-radius: 3px;
  margin: 8px;
  background-color: #eaeaea;
  background-size: cover;
  position: relative;

  .iu-widget-item-close {
    position: absolute;
    background: #ffffff;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    top: -6px;
    right: -6px;
    cursor: pointer;
  }

  .iu-widget-item-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.iu-widget__controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -8px auto 24px;
}

.iu-widget__next-button {
  padding: 11px 32px;
  background: #ef3e42;
  border-radius: 65px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-transform: uppercase;
  color: #ffffff;
  display: inline-block;
  cursor: pointer;
}

.iu-widget__post-form {
  display: flex;
  flex-direction: column;
  margin: 24px 0;

  label {
    font-size: 12px;
    line-height: 15px;
    color: #959595;
  }

  input[type="text"] {
    font-size: 16px;
    line-height: 22px;
    color: #2c2c2c;
    padding: 11px 16px;
    border: 1px solid #d5d5d5;
    border-radius: 5px;
    margin: 8px 0 24px;
  }
}

.iu-widget-checkbox {
  position: relative;
  display: flex;

  input[type="checkbox"] {
    position: absolute;
    opacity: 0;

    &:checked + .iu-widget-checkbox__toggle:before {
      content: "";
      width: 8px;
      height: 5px;
      border-width: 0 0 1px 1px;
      border-style: solid;
      border-color: #2c2c2c;
      transform: rotate(-45deg);
      margin: -2px -2px 0 0;
    }
  }
}

.iu-widget-checkbox__toggle {
  border: 1px solid #2c2c2c;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  border-radius: 4px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iu-widget-checkbox__label {
  font-size: 12px;
  line-height: 16px;
  color: #2c2c2c;
  margin-right: 18px;
}

.iu-widget__back-button {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 19px;
  color: #2c2c2c;
  margin-right: 24px;
  width: 134px;
  cursor: pointer;

  span {
    flex-grow: 1;
    margin-top: 3px;
    border-bottom: 1px solid #c0c0c0;
  }
}

.iu-widget-message {
  background-color: #f4f4f4;
  padding: 18px 26px;
  display: flex;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;

  svg {
    margin-right: 14px;
    flex-shrink: 0;
  }
}

.iu-widget-upload__error {
  margin-top: 24px;

  background-color: #fcd8d9;

  & + .iu-widget-preview {
    margin-top: 0;
  }
}

.iu-widget-message-congrats {
  span {
    display: block;
  }
}

@media (max-width: 568px) {
  .iu-widget__overlay {
    overflow-y: auto;
    overflow-x: hidden;
    align-items: flex-start;
    min-width: auto;
    min-height: auto;
  }

  .iu-widget__popup {
    width: 100%;
    min-height: 100%;
    max-height: none;
    display: flex;
    flex-direction: column;
  }

  .iu-widget__close {
    width: 16px;
    height: 16px;
  }

  .iu-widget__title {
    text-align: left;
    font-size: 20px;
    line-height: 24px;
    margin-top: 0;
  }

  .iu-widget-upload {
    flex-grow: 1;
    justify-content: center;
  }

  .iu-widget-upload__text {
    .iu-widget-upload__text--desktop {
      display: none;
    }

    .iu-widget-upload__text--mobile {
      display: inherit;
    }
  }

  .iu-widget-upload__hint {
    .iu-widget-upload__hint--desktop {
      display: none;
    }

    .iu-widget-upload__hint--mobile {
      display: inherit;
    }
  }

  .iu-widget-upload--short {
    margin: 24px 0 0;
    padding-left: 72px;

    svg {
      width: 48px;
      height: 48px;
      top: 16px;
      left: 16px;
    }

    .iu-widget-upload__hint {
      margin-top: 8px;
    }

    & + .iu-widget-upload__error {
      margin-top: 8px;
    }
  }

  .iu-widget-upload__progress {
    flex-direction: column;
    margin-bottom: 8px;

    svg {
      margin: 0 0 18px 0;
    }
  }

  .iu-widget-preview {
    flex-grow: 1;
  }

  .iu-widget__media-list {
    padding: 10px;
  }

  .iu-widget__media-item {
    width: 38px;
    height: 38px;
    margin: 6px;
  }

  .iu-widget__post-form + .iu-widget__controls {
    flex-direction: column;
    flex-grow: 1;

    .iu-widget__next-button {
      order: -1;
    }

    .iu-widget__back-button {
      margin: 16px 0 0;
    }
  }

  .iu-widget-message-congrats {
    span {
      display: inline-block;
    }
  }
}
</style>
